/* eslint-disable no-unreachable */
// Shared transform, should take in the offerBundle.offers from an offers-service response,
// turn them into something more "coherent", and return them
// modeled after ajax-offers.js parseData() (expected the entire response)
// currently this transform accepts (response.offerBundle.offers)
// TODO: since all offers are now using this, double check parseData's datalayer vs
// this one. IE: list_item_index is NOT currently included...
import $ from 'jquery';
import readableMonetize from 'lib/readable-monetize';
import PageCache from 'lib/page-cache';
import tdaConfig from 'lib/util/tda.config';
import tdaAll from 'lib/tda/all';
import bat from 'components/bat'; // bat.OFFER_DETAIL_MODAL
import 'lib/loader/series';
import './series.mapByCode';
import langFromUrl from 'lib/util/langFromUrl';
import __readableTitle from './offers.tmpl.common.title';
import __buildAriaLabel from './offers.tmpl.common.ariaLabel';
import {
  buildTitleContrived as __buildTitleContrived,
  buildExtrasContrived as __buildExtrasContrived,
  buildExtrasContrivedInline as __buildExtrasContrivedInline
} from './offers.tmpl.common.contrived';

function __readableMsrp(val) {
  if (!!val && !!val.accessory[0]) {
    return val.accessory[0].msrp;
  }
  return null;
}

function __readableImageSrc(val) {
  return val.replace('[A-Za-z0-9]', '').toLowerCase();
}

function __translateOfferLabel(label, __lang) {
  var ret = label;
  if (__lang === 'es') {
    var transList = {
      'TFS Cash': 'de bono TFS',
      'EN EFECTIVO TFS': 'en Efectivo TFS',
      'Loyalty Cash': 'de Loyalty Cash',
      'College Graduate': 'para graduados de college',
      Military: 'para militares',
      'Customer Cash': 'de reembolso',
      'ToyotaCare No Cost Maintenance Plan': 'Plan de mantenimiento sin costo ToyotaCare',
      'College Grad Rebate': 'Reembolso para graduados de college',
      'Military Rebate': 'Reembolso para militares',
      // 'Lease to Lease Loyalty Cash': 'Arrendamiento para alquilar dinero de fidelidad',
      'Certified Used Vehicle Special APR Program': 'Programa especial de APR para Vehículos Usados Certificados',
      'Certified Used Vehicle Special Lease Program': 'Programa de arrendamiento para Vehículos Usados Certificados',
      'Up to $4,500 Federal Tax Credit': 'Hasta $4,500 de crédito fiscal federal'
    };
    var tr = transList[label];
    if (tr) ret = tr;
  }
  return ret;
}

// offers data is supplemented with transformed series data (series.map). We must await that
export default function (offers) {
  return PageCache.await('series.map').then(function (seriesMap) {
    var items = [];
    var getTrimNameArray = [];
    var _lang = langFromUrl();

    for (var i = 0; i < offers.length; i += 1) {
      var dataLayerTempCat = offers[i].offerLabel === 'Parts & Service' ? 'pasm' : 'Vehicle';
      var extraCashLabelTxt = '';
      // Multi vehicle offers can't use this version of the seriesMap
      // we make those empty strings. Right now, old parseData func is making them undefined
      var displayName;

      try {
        displayName = seriesMap[offers[i].seriesList.series.id].series_display_name;
      } catch (e) {
        displayName = '';
      }
      var trimName = '';
      var applicableTrims = [];

      if (offers[i].seriesList.series.includedModels) {
        applicableTrims = offers[i].seriesList.series.includedModels.includedModel;
        if (offers[i].seriesList.series.includedModels.includedModel.length === 1) {
          trimName = offers[i].seriesList.series.includedModels.includedModel[0].name;
        }
      }

      // BAT-3844
      var cardImgAltTag;
      if (offers[i].offerCard.cardImageAlt !== '') {
        cardImgAltTag = offers[i].offerCard.cardImageAlt;
      }
      if (offers[i].seriesList.series.year && offers[i].seriesList.series.name) {
        cardImgAltTag = offers[i].seriesList.series.year + ' ' + offers[i].seriesList.series.name + ' ' + offers[i].offerType;
      } else {
        cardImgAltTag = offers[i].offerType;
      }

      var obj = {
        site_context: tdaConfig.site.context_url + '/',
        tda_short: tdaConfig.site.context_url.replace('es/', ''),
        id: offers[i].offerId,
        offerLabel: offers[i].offerLabel,
        description: __translateOfferLabel(offers[i].description, _lang),
        ribbon: {
          label: offers[i].offerLabel,
          colorNumber: offers[i].offerLabelNum
        },
        model: {
          year: offers[i].seriesList.series.year,
          name: displayName,
          code: offers[i].seriesList.series.id,
          trimName: trimName,
          applicableTrims: applicableTrims
        },
        image: {
          src: offers[i].offerCard.cardImage,
          alt: cardImgAltTag,
          srcDetail: offers[i].offerImage,
          is3dImgService: false
        },
        offerBadges: {
          cardBadgeImage1: tdaAll.localImgPath(offers[i].offerCard.cardBadgeImage1) || '',
          cardBadgeImage2: tdaAll.localImgPath(offers[i].offerCard.cardBadgeImage2) || '',
          cardBadgeImage3: tdaAll.localImgPath(offers[i].offerCard.cardBadgeImage3) || ''
        },
        offerImageDisclaimer: offers[i].offerImageDisclaimer || '',
        dataLayer: {
          link_text: 'View Offer',
          offer_category: dataLayerTempCat,
          offer_type: '',
          offer_id: offers[i].offerId,
          offer_expired_date: '',
          offer_term: '',
          offer_rate: '',
          offer_amtdue: '',
          offer_monthly: '',
          offer_cashback: '',
          offer_title: '',
          offer_label: offers[i].offerLabel,
          offer_series_code: displayName,
          offer_series_year: offers[i].seriesList.series.year,
          offer_series_number: '',
          offer_series_vehicleid: '',
          offer_series_inventory_type: 'New',
          offer_series_brand: 'Toyota',
          offer_series_category: '',
          offer_series_fuel_type: '',
          offer_series_msrp: '',
          offer_series_grade: '',
          offer_series_engine: '',
          offer_series_transmission: '',
          offer_series_body_style: '',
          offer_series_packages: '',
          offer_series_color_ext: '',
          offer_series_color_int: '',
          offer_series_color_ext_code: '',
          offer_series_color_int_code: '',
          offer_series_accessories_name: '',
          // 'offer_list_result_count': numOfOffers.toString(), // see also: all-offers.js, where we update this.
          // 'offer_list_filter': '', // updated via filters.js
          // 'offer_list_layout': // Need to get this each time! (see all-offers.js, offers-strip.js). Can we see if it's set or not first?
          offer_list_selector: ''
          // 'list_result_count': numOfOffers.toString(),
          // 'list_item_index': ((startingIndex + 1) + i).toString() //add 1 to starting index because we want our first item to be 1, not 0
        }
      };

      // BAT-2344, Vehicle Image Picker, we need to mark images that come from the VIP
      if (obj.image.src && obj.image.src.indexOf('inventoryswap/') > -1) {
        obj.image.is3dImgService = true;
        obj.image.src = obj.image.src.replace('inventoryswap/', '');
      }
      if (obj.image.srcDetail && obj.image.srcDetail.indexOf('inventoryswap/') > -1) {
        obj.image.is3dImgService = true;
        obj.image.srcDetail = obj.image.srcDetail.replace('inventoryswap/', '');
      }

      // Domain Restructure, TDA local images
      if (obj.image.src && obj.image.src.indexOf('/web_docs/') > -1) {
        obj.image.src = tdaAll.localImgPath(obj.image.src);
      }
      if (obj.image.srcDetail && obj.image.srcDetail.indexOf('/web_docs/') > -1) {
        obj.image.srcDetail = tdaAll.localImgPath(obj.image.srcDetail);
      }

      // ASSETS CASE
      if (obj.image.src && obj.image.src.indexOf('assets/assets/') > -1) {
        obj.image.is3dImgService = true;
        obj.image.src = obj.image.src.replace('assets/assets/', 'assets/');
      }
      if (obj.image.srcDetail && obj.image.srcDetail.indexOf('assets/assets/') > -1) {
        obj.image.is3dImgService = true;
        obj.image.srcDetail = obj.image.srcDetail.replace('assets/assets/', 'assets/');
      }

      // BAT-4570 If image querying from the 3d image service and needs to be adjusted
      var fSI = obj.image.src.lastIndexOf('/');
      var imageName = obj.image.src.substring(fSI + 1);
      if (obj.image.src && obj.image.src.indexOf('config/pub/3d/toyota/') > -1 && imageName.length > 20) {
        obj.image.is3dImgService = true;
      }

      // CORE-11, remove leading '/', this leading slash is output in the DOM by $URL_PREFIX
      // Note: this handles all offers (including those found on /landing/dealer_offers_frame/)
      if (obj.image.src && obj.image.src.indexOf('/') === 0) {
        obj.image.src = obj.image.src.replace('/', tdaConfig.site.url_prefix);
      }
      if (obj.image.srcDetail !== null) {
        if (obj.image.srcDetail.indexOf('/') === 0) {
          obj.image.srcDetail = obj.image.srcDetail.replace('/', tdaConfig.site.url_prefix);
        }
      }

      if (offers[i].endDate) {
        var endDate = offers[i].endDate.split('-');
        var string = endDate[1] + '/' + endDate[2] + '/' + endDate[0];
        var stringShort = endDate[1] + '/' + endDate[2];
        obj.endDate = string;
        obj.__endDate = offers[i].endDate;
        obj.endDateShort = stringShort;
        obj.dataLayer.offer_expired_date = stringShort;
      }

      // BAT-2980: USE FULL LIST OF BULLETS
      obj.bullets = $.extend(true, [], offers[i].bullets.bullet);
      // BAT-2986: ADD DISCLAIMERS & RESTRICTIONS.
      obj.disclaimers = offers[i].disclaimers;
      obj.restrictions = offers[i].restrictions;
      obj.additionalDisclaimers = offers[i].additionalDisclaimers;
      obj.additionalRestrictions = offers[i].additionalRestrictions;

      if (offers[i].apr && offers[i].apr.tiers.tier[0]) {
        if (offers[i].apr.tiers.tier[0].term[0].extraCashLabel === 'Subvention cash') {
          extraCashLabelTxt = 'Subvention cash';
          obj.subvention = true;
        } else {
          extraCashLabelTxt = offers[i].apr.tiers.tier[0].term[0].extraCashLabel;
        }

        obj.offerType = 'apr';
        obj.offerTypeTitle = 'apr';
        obj.dataLayer.offer_type = obj.offerType;
        obj.extraCashAmount = readableMonetize(offers[i].apr.tiers.tier[0].term[0].extraCashAmount);
        obj.dataLayer.offer_cashback = obj.extraCashAmount;
        obj.extraCashLabel = extraCashLabelTxt;
        obj.downPayment = offers[i].apr.downPayment;
        obj.apr = {
          duration: offers[i].apr.tiers.tier[0].term[0].duration,
          rate: offers[i].apr.tiers.tier[0].term[0].rate.toString(),
          monthlyPayment: readableMonetize(offers[i].apr.monthlyPayment),
          title: __readableTitle(offers[i].offerCard.cardTitle, offers[i].offerCard.cardTitle),
          creditRating: offers[i].apr.tiers.tier[0].level
        };
        obj.dataLayer.offer_term = obj.apr.duration;
        obj.dataLayer.offer_rate = obj.apr.rate;
        obj.dataLayer.offer_monthly = obj.apr.monthlyPayment;
        obj.dataLayer.offer_title = obj.apr.title;

        obj.tiers = offers[i].apr.tiers.tier;

        var yearLength = obj.model.year.split(',').length;
        var year = yearLength === 1 ? '/' + obj.model.year : '';

        if (obj.image.src === '') {
          obj.image.src = tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-card.png';
        }

        if (!obj.image.srcDetail || obj.image.srcDetail === '') {
          obj.image.srcDetail = tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-detail.png';
        }

      } else if (offers[i].lease && offers[i].lease.tiers.tier[0]) {
        if (offers[i].lease.tiers.tier[0].term[0].extraCashLabel === 'Subvention cash') {
          extraCashLabelTxt = 'Subvention cash';
          obj.subvention = true;
        } else {
          extraCashLabelTxt = offers[i].lease.tiers.tier[0].term[0].extraCashLabel;
        }

        obj.offerType = 'lease';
        obj.offerTypeTitle = _lang === 'es' ? 'arrendar' : 'lease';
        obj.dataLayer.offer_type = obj.offerType;
        obj.extraCashAmount = readableMonetize(offers[i].lease.tiers.tier[0].term[0].extraCashAmount);
        obj.dataLayer.offer_cashback = obj.extraCashAmount;
        obj.extraCashLabel = extraCashLabelTxt;
        obj.downPayment = offers[i].lease.downPayment;
        obj.lease = {
          duration: offers[i].lease.tiers.tier[0].term[0].duration,
          monthlyPayment: readableMonetize(offers[i].lease.tiers.tier[0].term[0].monthlyPayment),
          dueAtSigningAmount: readableMonetize(offers[i].lease.tiers.tier[0].term[0].dueAtSigningAmount),
          msrp: __readableMsrp(offers[i].lease.accessories),
          title: __readableTitle(offers[i].offerCard.cardTitle, offers[i].offerCard.cardTitle),
          allowableMileage: offers[i].lease.tiers.tier[0].term[0].allowableMileage,
          creditRating: offers[i].lease.tiers.tier[0].level,
        };
        obj.dataLayer.offer_term = obj.lease.duration;
        obj.dataLayer.offer_amtdue = obj.lease.dueAtSigningAmount;
        obj.dataLayer.offer_monthly = obj.lease.monthlyPayment;
        obj.dataLayer.offer_title = obj.lease.title;

        obj.tiers = offers[i].lease.tiers.tier;

        var yearLength = obj.model.year.split(',').length;
        var year = yearLength === 1 ? '/' + obj.model.year : '';

        if (obj.image.src === '') {
          obj.image.src = tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-card.png';
        }

        if (!obj.image.srcDetail || obj.image.srcDetail === '') {
          obj.image.srcDetail = tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-detail.png';
        }

      } else if (offers[i].cash) {
        if (offers[i].extraCashLabel === 'Subvention cash') {
          extraCashLabelTxt = 'Subvention cash';
          obj.subvention = true;
        } else {
          extraCashLabelTxt = offers[i].extraCashLabel;
        }

        obj.offerType = 'cash';
        obj.offerTypeTitle = _lang === 'es' ? 'en efectivo' : 'cash';
        // BAT-5020 (GST only, see offers-ajax-filtered.js)
        if (offers[i].bonus === true) {
          obj.bonus = true;
        } else {
          // BAT-5020 change offer type for GST TFS Cash and Bonus Cash to Bonus
          var ofr = offers[i];
          var tfsDefLabel = 'tfs cash';
          var tfsLabel = _lang === 'es' ? 'en efectivo tfs' : tfsDefLabel;
          var bonusDefLabel = 'bonus';
          var bonusLabel = _lang === 'es' ? 'en bono' : bonusDefLabel;
          if (tdaConfig.tda.code === 'GST10' && ofr.offerType.toLowerCase() === 'cash'
              && ofr.cash && ofr.cash.subTypeLabels
              && (ofr.cash.subTypeLabels.toLowerCase() === tfsDefLabel || ofr.cash.subTypeLabels.toLowerCase() === tfsLabel
              || ofr.cash.subTypeLabels.toLowerCase() === bonusDefLabel || ofr.cash.subTypeLabels.toLowerCase() === bonusLabel)) {
            obj.bonus = true;
          }
        }
        obj.dataLayer.offer_type = obj.offerType;
        obj.extraCashAmount = readableMonetize(offers[i].extraCashAmount);
        obj.dataLayer.offer_cashback = obj.extraCashAmount;
        obj.extraCashLabel = extraCashLabelTxt;

        obj.cash = {
          amount: readableMonetize(offers[i].cash.cashAmount),
          label: __translateOfferLabel(offers[i].cash.subTypeLabels, _lang),
          stackableWithApr: offers[i].cash.stackableWithApr.toString(),
          stackableWithLease: offers[i].cash.stackableWithLease.toString(),
          title: __translateOfferLabel(__readableTitle(offers[i].offerCard.cardTitle, offers[i].title), _lang)
          //title: __readableTitle(offers[i].offerCard.cardTitle, offers[i].offerCard.cardTitle)
        };

        obj.amount = readableMonetize(offers[i].cash.cashAmount);
        // BOTH CASH AND MULTI RUN THROUGH SAME TEMPLATE. amount AND title AND cashTypeLabel used in templates
        // obj.adjustedTitle = obj.model.year + ' ' + obj.model.name;
        // ADJUSTTED CARD TITLE IS USED IN inventory-detail available offers templates.
        obj.adjustedCardTitle = obj.model.year + ' ' + obj.model.name; // TRIM NAME GETS APPENDED TO MODEL WHEN READY AND WIL FAIL GRACEFULLY IN TEMPLATE.
        if (offers[i].cash.subTypeLabels) {
          obj.cashTypeLabel = offers[i].cash.subTypeLabels;
        }
        /*
        console.log('\n__________  CASH __________')
        console.log(' :::' + i + ' CASH offers[i].title; ',offers[i].title);
        console.log(' :::' + i + ' CASH offerCard.cardTitle: ', offers[i].offerCard.cardTitle);
        console.log(' :::' + i + ' CASH offers[i].offerLabel: ',offers[i].offerLabel);
        console.log(' :::' + i + ' CASH obj.adjustedCardTitle) ',obj.adjustedCardTitle);
        console.log('  ::: ID', obj.id);
        console.log('  ::: OFFER', offers[i]);
        console.log('____________________\n');
        */
        obj.dataLayer.offer_cashback = obj.amount;
        obj.dataLayer.offer_title = obj.cash.title;

        obj.cash.cannotBeCombinedWithIds = offers[i].cash.cannotBeCombinedWith.offerId;
        for (var q = 0; q < obj.cash.cannotBeCombinedWithIds.length; q++) {
          var properId = obj.cash.cannotBeCombinedWithIds[q].substr(obj.cash.cannotBeCombinedWithIds[q].lastIndexOf('/') + 1).split('.xml').join('');
          obj.cash.cannotBeCombinedWithIds[q] = properId;
        }

        obj.cash.cannotBeCombinedWithIds = obj.cash.cannotBeCombinedWithIds.join('|');

        var yearLength = obj.model.year.split(',').length;
        var year = yearLength === 1 ? '/' + obj.model.year : '';

        if (obj.image.src === '') {
          obj.image.src =  tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-card.png';
        }

        if (!obj.image.srcDetail || obj.image.srcDetail === '') {
          obj.image.srcDetail =  tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-detail.png';
        }
      } else if (offers[i].miscellaneous) {
        obj.offerType = 'misc';
        obj.offerTypeTitle = 'misc';
        obj.dataLayer.offer_type = obj.offerType;
        obj.miscellaneous = {
          amount: readableMonetize(offers[i].cashAmount),
          title: __translateOfferLabel(__readableTitle(offers[i].offerCard.cardTitle, offers[i].title), _lang),
          description: offers[i].description,
          label: offers[i].miscellaneous.subTypeLabels
        };

        obj.model.code = '';

        for (var v = 0; v < offers[i].seriesList.series.length; v++) {
          obj.model.code += offers[i].seriesList.series[v].id.split(',').join(' ') + ' ';
        }
      } else if (offers[i].msrpAmount) {
        obj.offerType = 'msrp';
        obj.offerTypeTitle = 'msrp';
        obj.dataLayer.offer_type = obj.offerType;
        obj.msrp = {
          title: __translateOfferLabel(__readableTitle(offers[i].offerCard.cardTitle, offers[i].title), _lang),
          description: offers[i].description,
          amount: readableMonetize(offers[i].msrpAmount)
        };
        var yearLength = obj.model.year.split(',').length;
        var year = yearLength === 1 ? '/'+obj.model.year : '';

        if (obj.image.src === '') {
          obj.image.src = tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-card.png';
        }

        if (!obj.image.srcDetail || obj.image.srcDetail === '') {
          obj.image.srcDetail = tdaConfig.site.url_prefix + 'assets/img/vehicles/' + __readableImageSrc(offers[i].seriesList.series.id) + year + '/default-offer-detail.png';
        }
      } else if (offers[i].multivehicle) {
        obj.offerType = 'cash';
        obj.offerTypeTitle = _lang === 'es' ? 'en efectivo' : 'cash';
        obj.dataLayer.offer_type = obj.offerType;
        obj.multivehicle = {
          title: __translateOfferLabel(__readableTitle(offers[i].offerCard.cardTitle, offers[i].title), _lang),
          //title: __readableTitle(offers[i].offerCard.cardTitle, offers[i].title),
          amount: readableMonetize(offers[i].multivehicle.cashAmount),
          label: __translateOfferLabel(offers[i].multivehicle.subTypeLabels, _lang)
        };

        obj.amount = readableMonetize(offers[i].multivehicle.cashAmount);
        obj.adjustedTitle = offers[i].title; // BOTH CASH AND MULTI RUN THROUGH SAME TEMPLATE. amount AND title AND cashTypeLabel used in templates
        // ADJUSTED CARD TITLE IS USED IN inventory-detail available offers templates.
        // WE'RE DOING THIS HERE BECAUSE OFFERS COMING FROM OTB SEEM TO HAVE null FOR TITLE.
        // obj.adjustedCardTitle = offers[i].title || offers[i].offerLabel;
        obj.adjustedCardTitle = offers[i].offerCard.cardTitle || offers[i].offerLabel; // PLUG THESE INTO READABLE TITLE?;

        /*
        console.log('\n__________  MULTI __________')
        console.log(' :::' + i + ' MULTI offers[i].title; ',offers[i].title);
        console.log(' :::' + i + ' MULTI offerCard.cardTitle: ', offers[i].offerCard.cardTitle);
        console.log(' :::' + i + ' MULTI offers[i].offerLabel: ',offers[i].offerLabel);
        console.log(' :::' + i + ' MULTI obj.adjustedCardTitle): ',obj.adjustedCardTitle);
        console.log('  ::: ID', obj.id);
        console.log('  ::: OFFER', offers[i]);
        console.log('____________________\n')
        */

        if (offers[i].multivehicle.subTypeLabels) {
          obj.cashTypeLabel = offers[i].multivehicle.subTypeLabels;
        }
        obj.dataLayer.offer_cashback = obj.amount;
        obj.dataLayer.offer_title = obj.multivehicle.title;

        obj.multivehicle.cannotBeCombinedWithIds = offers[i].multivehicle.cannotBeCombinedWith.offerId;
        for (var q = 0; q < obj.multivehicle.cannotBeCombinedWithIds.length; q++) {
          var properId = obj.multivehicle.cannotBeCombinedWithIds[q].substr(obj.multivehicle.cannotBeCombinedWithIds[q].lastIndexOf('/') + 1).split('.xml').join('');
          obj.multivehicle.cannotBeCombinedWithIds[q] = properId;
        }

        obj.multivehicle.cannotBeCombinedWithIds = obj.multivehicle.cannotBeCombinedWithIds.join('|');
        obj.model.code = '';
        for (var v = 0; v < offers[i].seriesList.series.length; v++) {
          obj.model.code += offers[i].seriesList.series[v].id.split(',').join(' ') + ' ';
        }

        // BAT-2986. leading slashes from assets/etc were removed.
        if (obj.image.src === '') {
          obj.image.src = tdaConfig.site.url_prefix + 'assets/img/vehicles/multivehicle_default.png';
        }

        if (!obj.image.srcDetail || obj.image.srcDetail === '') {
          obj.image.srcDetail = tdaConfig.site.url_prefix +  'assets/img/vehicles/multivehicle_default.png';
        }
      }

      if (offers[i].seriesList.series.included) {
        var val = offers[i].seriesList.series.included;
        var trim = {};
        var array = val.split(', ');
        if (array.length === 1) {
          var trimCode = array[0];
          var trimId;
          var year;

          // bad data patch
          if (trimCode.indexOf('-') > -1) {
            year = trimCode.split('-')[0];
            trimId = trimCode.split('-')[1];
          } else {
            year = offers[i].seriesList.series.year;
            trimId = trimCode;
          }
          getTrimNameArray.push({ obj: obj, trimCode: trimId, year: year }); // push offers with only 1 trim id to array to get trim names via CLS
        }

        trim.codes = 'trim-';
        trim.codes += val.split(', ').join(' trim-');
        obj.trim = trim;
      } else {
        obj.trim = {};
        obj.trim.codes = 'all-trims';
      }
      // DL-45, if offer has more than one trim, use 'general'
      obj.dataLayer.offer_series_number = obj.trim.codes;
      var offerSeriesNumberCount = obj.dataLayer.offer_series_number.split(' ');
      if (offerSeriesNumberCount.length > 1) {
        obj.dataLayer.offer_series_number = 'general';
      } else {
        obj.dataLayer.offer_series_number = obj.dataLayer.offer_series_number;
      }

      // Offer detail modal
      // since parseData is now using this, we need the OFFER_DETAIL_MODAL handling here
      // TODO: this should live elsewhere in the end though...
      // Offer detail modal
      bat.OFFER_DETAIL_MODAL[obj.id] = $.extend(true, {}, obj);
      bat.OFFER_DETAIL_MODAL[obj.id].bullets = $.extend(true, [], offers[i].bullets.bullet);

      $.each(bat.OFFER_DETAIL_MODAL[obj.id].bullets, function (index, value) {
        if (value.text.indexOf('href=') > -1) { value.text = null; }
        if (value.link != '') { value.text = null; }
      });

      if (bat.OFFER_DETAIL_MODAL[obj.id].image.src.indexOf('default-offer-card') > -1) {
        var offerDetailSrc = bat.OFFER_DETAIL_MODAL[obj.id].image.src.split('default-offer-card').join('default-offer-detail');
        bat.OFFER_DETAIL_MODAL[obj.id].image.src = offerDetailSrc;
      }

      bat.OFFER_DETAIL_MODAL[obj.id].disclaimers = [];

      if (offers[i].additionalDisclaimers != '') { bat.OFFER_DETAIL_MODAL[obj.id].disclaimers.push(offers[i].additionalDisclaimers); }
      if (offers[i].additionalRestrictions != '') { bat.OFFER_DETAIL_MODAL[obj.id].disclaimers.push(offers[i].additionalDisclaimers); }
      if (offers[i].disclaimers.disclaimer) {
        $.each(offers[i].disclaimers.disclaimer, function (index, value) {
          if (value != '') { bat.OFFER_DETAIL_MODAL[obj.id].disclaimers.push(value); }
        });
      }
      if (offers[i].restrictions.restriction) {
        $.each(offers[i].restrictions.restriction, function (index, value) {
          if (value != '') { bat.OFFER_DETAIL_MODAL[obj.id].disclaimers.push(value); }
        });
      }

      // check for ANY null properties on our data layer object
      // if we find one, set it to an empty string
      for (var key in obj.dataLayer) {
        if (obj.dataLayer[key] == null) {
          obj.dataLayer[key] = '';
        }
      }

      obj.ariaLabel = __buildAriaLabel(obj);
      obj.titleContrivedHtml = __buildTitleContrived(obj, offers[i].offerCard);
      obj.extrasContrivedHtml = __buildExtrasContrived(obj, offers[i].offerCard);
      obj.extrasContrivedInlineHtml = __buildExtrasContrivedInline(obj, offers[i].offerCard);
      obj.lang = _lang;
      obj.isEndDateHidden = offers[i].isEndDateHidden ? 'true' : 'false';
      items.push(obj);
    }
    return items;

  });
};
